<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-if="turno">{{ turno.NOME }}</dd>
  </div>
</template>

<script>
import TurnoService from "../../../../domain/corpore/TurnoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "view-c-protocolo-turno-colegio",
  props: {
    label: String,
    value: String
  },
  asyncComputed: {
    turno() {
      const turnoService = new TurnoService(this.$http);
      return turnoService
        .getTurnosColegio()
        .then(result => result.find(turno => this.value == turno.CODTURNO))
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/TurnoColegio.vue